import { useSyncSalonId } from "hooks";

/** Manage state of the app within the context of BrowserRouter */
export const AppStateManager = () => {
  useSyncSalonId();

  return null;
};
